import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import AuthApi from "../api/authApi";
import companyLogo from "../assets/images/logo.png";
import Cookies from "universal-cookie";

const RegistrationPasswordAuth = ({ children, onVerified }) => {
  const cookies = new Cookies();
  const userData = cookies.get("LoveStrongUser") || null;
  const isAdmin = userData && userData.userRole === "ADMIN";

  const [isVerified, setIsVerified] = useState(
    isAdmin || !!sessionStorage.getItem("retreat-registration-password"),
  );
  const [registrationPassword, setRegistrationPassword] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);
  let authApi = new AuthApi();

  const handleVerifyPassword = async () => {
    if (!registrationPassword) {
      toast.error("Please enter the registration password.");
      return;
    }
    setIsVerifying(true);
    await authApi
      .verifyRegistrationPassword({ password: registrationPassword })
      .then((res) => {
        setIsVerifying(false);
        if (res.success && res.valid) {
          sessionStorage.setItem(
            "retreat-registration-password",
            registrationPassword,
          );
          setIsVerified(true);
          if (onVerified) {
            onVerified();
          }
          toast.success("Password verified successfully!");
        } else {
          toast.error(res.msg || "Invalid password.");
        }
      })
      .catch((err) => {
        setIsVerifying(false);
        toast.error("Incorrect password. Please try again.");
      });
  };

  if (!isVerified) {
    return (
      <div className="container-scroller mainpannel">
        <div className="container-fluid page-body-wrapper full-page-wrapper">
          <div className="content-wrapper d-flex align-items-center auth px-0">
            <div className="row w-100 mx-0">
              <div className="col-lg-4 mx-auto">
                <div
                  className="auth-form-light text-left py-5 px-4 px-sm-5 text-center shadow"
                  style={{ borderRadius: "10px" }}
                >
                  <Link to="/">
                    <div className="brand-logo mb-4">
                      <img
                        src={companyLogo}
                        alt="logo"
                        className="logo center"
                      />
                    </div>
                  </Link>
                  <h4 className="font-weight-light">
                    New Retreat Registration
                  </h4>
                  <h6 className="font-weight-light mb-4">
                    Please enter the registration password to continue.
                  </h6>
                  <Form className="pt-3">
                    <Form.Group className="mb-4">
                      <Form.Control
                        type="password"
                        placeholder="Registration Password"
                        size="lg"
                        value={registrationPassword}
                        onChange={(e) =>
                          setRegistrationPassword(e.target.value)
                        }
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleVerifyPassword();
                          }
                        }}
                      />
                    </Form.Group>
                    <div className="mt-3">
                      <Button
                        className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn w-100"
                        onClick={handleVerifyPassword}
                        disabled={isVerifying}
                      >
                        {isVerifying ? "Verifying..." : "Confirm"}
                      </Button>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default RegistrationPasswordAuth;
